import { hocs } from '@approvalmax/utils';

import { ReactComponent as IconSmall } from './arrow-left.small.svg';
import { ReactComponent as Icon } from './arrow-left.svg';

export const ArrowLeftIcon = hocs.withSmallIcon(Icon, IconSmall);
